<h1 mat-dialog-title>Give access to our IP address</h1>
<mat-dialog-content>
    <p class="mat-body">
        Please make sure our servers are able to access your database. Rocketadmin uses the IP address <app-ip-address-button ip="18.221.81.73"></app-ip-address-button> for all outbound requests.
    </p>
    <br>
    <div *ngIf="data.provider === 'amazon'" class="mat-body">
        <strong>Set up AWS's VPC security groups</strong>
        <ol class="rules">
            <li>Open the Amazon RDS <strong>console</strong>.</li>
            <li>
                In the navigation pane, choose <strong>Databases</strong> and open your database overview.
                On the tab <strong>Connectivity & security</strong> find the section <strong>Security&nbsp;/&nbsp;VPC security groups</strong>.
            </li>
            <li>Open your VPC security group overview and then click <strong>Edit inbound rules</strong>.</li>
            <li>
                Click <strong>Add Rule</strong>, and enter the following information: <br/>
                <strong>Type</strong> — your db type; <br/>
                <strong>Source</strong> — select <strong>Custom</strong> and enter
                <app-ip-address-button ip="18.221.81.73/32"></app-ip-address-button>.
            </li>
            <li>Click <strong>Save</strong>.</li>
        </ol>
    </div>
    <div *ngIf="data.provider === 'azure'" class="mat-body">
        <strong>Set up Azure's firewall rules</strong>
        <ol class="rules">
            <li>Open your database overview and select <strong>Networking</strong> from the navigation pane.</li>
            <li>In the <strong>Connectivity method</strong> you have to have <strong>Public access (allowed IP addresses)</strong>.</li>
            <li>
                Add a rule to the Firewall rules table. Enter any Firewall rule name,
                Start IP address: <app-ip-address-button ip="18.221.81.73"></app-ip-address-button>,
                End IP address: <app-ip-address-button ip="18.221.81.73"></app-ip-address-button>.
            </li>
            <li>Click <strong>Save</strong>.</li>
        </ol>
    </div>
    <div *ngIf="data.provider === 'google'" class="mat-body">
        <strong>Set up Google Cloud's authorized networks</strong>
        <ol class="rules">
            <li>Open your instance overview and select <strong>Connections</strong> from the navigation pane.</li>
            <li>
                Tick the <strong>Public IP</strong> checkbox and click <strong>Add network</strong> in <strong>Authorized networks</strong> section.
            </li>
            <li>Enter any name and  <app-ip-address-button ip="18.221.81.73"></app-ip-address-button> IP address for a <strong>New network</strong>.</li>
            <li>Click <strong>Done</strong> and then <strong>Save</strong> to update the instance.</li>
        </ol>
    </div>
    <ng-container *ngIf="data.provider === null">
        <div *ngIf="data.db.type === 'postgres'" class="mat-body">
            Give privileges to a user:
            <div class="codeSnippet">
                <code class="code">
                    <pre>GRANT CONNECT ON DATABASE &quot;{{data.db.database}}&quot; TO &quot;{{data.db.username}}&quot;;</pre>
                    <pre>ALTER DEFAULT PRIVILEGES IN SCHEMA &quot;{{data.db.schema || 'public'}}&quot; GRANT SELECT, INSERT, UPDATE, DELETE ON TABLES TO &quot;{{data.db.username}}&quot;;</pre>
                    <pre>GRANT SELECT, INSERT, UPDATE, DELETE ON ALL TABLES IN SCHEMA "public" TO &quot;{{data.db.username}}&quot;;</pre>

                </code>
                <button type="button" mat-icon-button
                    matTooltip="Copy the command."
                    cdkCopyToClipboard="GRANT CONNECT ON DATABASE &quot;{{data.db.database}}&quot; TO &quot;{{data.db.username}}&quot;;
ALTER DEFAULT PRIVILEGES IN SCHEMA &quot;{{data.db.schema || 'public'}}&quot; GRANT SELECT, INSERT, UPDATE, DELETE ON TABLES TO &quot;{{data.db.username}}&quot;;
GRANT SELECT, INSERT, UPDATE, DELETE ON ALL TABLES IN SCHEMA &quot;{{data.db.schema || 'public'}}&quot; TO &quot;{{data.db.username}}&quot;;"
                    (cdkCopyToClipboardCopied)="showCopyNotification('Command was copied to clipboard.')">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>

            Add the following line in file pg_hba.conf (/var/lib/pgsql/data/pg_hba.conf for Linux).

            <div class="codeSnippet">
                <code class="code">
                    <pre>host    all    all    18.221.81.73/32    trust</pre>
                </code>
                <button type="button" mat-icon-button
                    matTooltip="Copy the command."
                    cdkCopyToClipboard="host    all         all         18.221.81.73/32    trust"
                    (cdkCopyToClipboardCopied)="showCopyNotification('Command was copied to clipboard.')">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <div *ngIf="data.db.type === 'mysql'" class="mat-body">
            Give privileges to user and allow to connect: <br/>

            <div class="codeSnippet">
                <code class="code">
                    <pre>GRANT ALL PRIVILEGES ON {{data.db.database}} TO `{{data.db.username}}`&#64;`18.221.81.73` IDENTIFIED BY `&lt;password&gt;` WITH GRANT OPTION;</pre>
                </code>
                <button type="button" mat-icon-button
                    matTooltip="Copy the command."
                    cdkCopyToClipboard="GRANT ALL PRIVILEGES ON {{data.db.database}} TO `{{data.db.username}}`@`18.221.81.73` IDENTIFIED BY `&lt;password&gt;` WITH GRANT OPTION;"
                    (cdkCopyToClipboardCopied)="showCopyNotification('Command was copied to clipboard.')">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>

            and then

            <div class="codeSnippet">
                <code class="code">
                    <pre>FLUSH PRIVILEGES;</pre>
                </code>
                <button type="button" mat-icon-button
                    matTooltip="Copy the command."
                    cdkCopyToClipboard="FLUSH PRIVILEGES;"
                    (cdkCopyToClipboardCopied)="showCopyNotification('Command was copied to clipboard.')">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <div *ngIf="data.db.type === 'oracledb'" class="mat-body">
            <p>
                Start the SQL PLUS Command Line and connect to the database as user SYSTEM.
                Provide the SYSTEM password that you assigned upon installation (Windows) or
                configuration (Linux) of Oracle Database XE. Run the following command:
            </p>

            <div class="codeSnippet">
                <code class="code">
                    <pre>EXEC DBMS_XDB.SETLISTENERLOCALACCESS(FALSE);</pre>
                </code>
                <button type="button" mat-icon-button
                    matTooltip="Copy the command."
                    cdkCopyToClipboard="EXEC DBMS_XDB.SETLISTENERLOCALACCESS(FALSE);"
                    (cdkCopyToClipboardCopied)="showCopyNotification('Command was copied to clipboard.')">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="data.provider === null" mat-button mat-dialog-close mat-dialog-close>Cancel</button>
    <a *ngIf="data.provider === 'amazon'" mat-button target="_blank"
        href="https://docs.rocketadmin.com/Create%20connections/Direct%20connection/create_aws_mysql">
        Setup guide
    </a>
    <a *ngIf="data.provider === 'azure'" mat-button target="_blank"
        href="https://learn.microsoft.com/en-us/azure/mysql/flexible-server/how-to-manage-firewall-portal">
        Setup guide
    </a>
    <a *ngIf="data.provider === 'google'" mat-button target="_blank"
        href="https://docs.rocketadmin.com/Create%20connections/Direct%20connection/create_google_cloud">
        Setup guide
    </a>
    <a *ngIf="data.provider === 'mongoatlas'" mat-button target="_blank"
        href="https://docs.rocketadmin.com/Create%20connections/Direct%20connection/create_mongo_atlas">
        Setup guide
    </a>
    <a *ngIf="data.provider === 'digitalocean'" mat-button target="_blank"
        href="https://docs.rocketadmin.com/Create%20connections/Direct%20connection/create_digitalocean_postgresql">
        Setup guide
    </a>
    <button mat-flat-button color="primary"
        mat-dialog-close="confirmed">
        I've given access
    </button>
</mat-dialog-actions>

